import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=804efff0&scoped=true&"
import script from "./EmailInput.vue?vue&type=script&lang=js&"
export * from "./EmailInput.vue?vue&type=script&lang=js&"
import style0 from "./EmailInput.vue?vue&type=style&index=0&id=804efff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804efff0",
  null
  
)

export default component.exports